import { useCallback } from 'react';
import { useLazyQuery } from '@apollo/client';
import { GET_UNVERIFIED_MEMBER_STEP_UP_URL } from '@pass-frontend/common/data-access';

export interface UseUnverifiedMemberResult {
  loading: boolean;
  error: string | null;
  fetchStepUpUrl: (searchId: string) => Promise<string | null>;
}

export const useUnverifiedMember = (): UseUnverifiedMemberResult => {
  const [fetchQuery, { loading, error }] = useLazyQuery(
    GET_UNVERIFIED_MEMBER_STEP_UP_URL,
    {
      errorPolicy: 'all',
      onError: (err) => {
        console.error('Failed to fetch unverified member step-up URL:', err);
      },
    },
  );

  const fetchStepUpUrl = useCallback(
    async (searchId: string): Promise<string | null> => {
      try {
        const result = await fetchQuery({ variables: { searchId } });
        if (result.error) {
          return null;
        }
        return result.data?.stepUpUrl || null;
      } catch (err) {
        console.error('Error fetching step-up URL:', err);
        return null;
      }
    },
    [fetchQuery],
  );

  return {
    loading,
    error: error ? error.message : null,
    fetchStepUpUrl,
  };
};
